export enum IntegrationTypes {
    Sence = 0,
    VideoConference = 1,
    Coursera = 2,
    Udemy = 3,
  }
  